
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv-rental",
      function () {
        return require("private-next-pages/tv-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv-rental"])
      });
    }
  